import { getCommandsModule } from './getCommandModule';
import { getContextModule } from './getContextModule';
import { getPanelModule } from './getPanelModule';
import { id } from './id';
import { init } from './init';
import React from 'react';
import { PreAnnotationsToggleButton } from './components/PreAnnotationsToggleButton';
import GleamerPredictionRectangleTool from './tools/GleamerPredictionRectangleTool';
import GleamerPredictionContourTool from './tools/GleamerPredictionContourTool';

export {
  PREDICTIONS_LOAD_FAILED_MESSAGE,
  useAllPredictions,
  useInitalPredictions,
  usePredictionsLoadFailed,
  useResetPredictions,
  useSetPredictions,
} from './contexts/predictions.hooks';

export { ConfidencesSlider } from './components/ConfidencesSlider';
export {
  hasReadPreAnnotations,
  keepDroppedPreAnnotations,
} from './preAnnotations/droppedPreAnnotations';

/**
 * You can remove any of the following modules if you don't need them.
 */
export default {
  /**
   * Only required property. Should be a unique value across all extensions.
   * You ID can be anything you want, but it should be unique.
   */
  id,

  /**
   * Perform any pre-registration tasks here. This is called before the extension
   * is registered. Usually we run tasks such as: configuring the libraries
   * (e.g. cornerstone, cornerstoneTools, ...) or registering any services that
   * this extension is providing.
   */
  preRegistration: ({
    servicesManager,
    commandsManager,
    configuration = {},
  }) => {
    init();
  },
  /**
   * PanelModule should provide a list of panels that will be available in OHIF
   * for Modes to consume and render. Each panel is defined by a {name,
   * iconName, iconLabel, label, component} object. Example of a panel module
   * is the StudyBrowserPanel that is provided by the default extension in OHIF.
   */
  getPanelModule,
  /**
   * CommandsModule should provide a list of commands that will be available in OHIF
   * for Modes to consume and use in the viewports. Each command is defined by
   * an object of { actions, definitions, defaultContext } where actions is an
   * object of functions, definitions is an object of available commands, their
   * options, and defaultContext is the default context for the command to run against.
   */
  getCommandsModule,
  /**
   * ContextModule should provide a list of context that will be available in OHIF
   * and will be provided to the Modes. A context is a state that is shared OHIF.
   * Context is defined by an object of { name, context, provider }. Examples include
   * the measurementTracking context provided by the measurementTracking extension.
   */
  getContextModule,

  getToolbarModule: ({ commandsManager }) => [
    {
      name: 'gleamer.preAnnotationsToggle',
      defaultComponent: (props) => (
        <PreAnnotationsToggleButton
          {...props}
          commandsManager={commandsManager}
        />
      ),
      clickHandler: () => {},
    },
  ],

  getUtilityModule: () => {
    return [
      {
        name: 'tools',
        exports: {
          predictionsToolNames: {
            [GleamerPredictionRectangleTool.toolName]:
              GleamerPredictionRectangleTool.toolName,
            [GleamerPredictionContourTool.toolName]:
              GleamerPredictionContourTool.toolName,
          },
        },
      },
    ];
  },
};
